import Cookies from 'js-cookie'

// 与后端保持一致的Cookie名称
const TokenKey = 'good_token'
const ExpiryKey = 'good_token_expiry'

// 直接从Cookie获取Token
export function getToken() {
    let token = localStorage.getItem(TokenKey) // 首先尝试从localStorage获取
    if (!token) { // 如果localStorage中没有，尝试从Cookie获取
        token = Cookies.get(TokenKey)
        if (token) { // 如果从Cookie获取到了，同时存储到localStorage以便后续使用
            localStorage.setItem(TokenKey, token)
        }
    }
    return token
}
// 检查Token有效性
export function isTokenValid() {
    const token = getToken()
    return token !== null
}
// 初始化Token检查
export async function initTokenCheck() {
    // 直接检查Token是否有效，不调用API
    return isTokenValid()
}
// 设置Token（带过期时间，单位：秒）
export function setToken(token, expirySeconds = 10800) { // 默认3小时
    const expiryDate = new Date().getTime() + (expirySeconds * 1000)
    localStorage.setItem(TokenKey, token) // 存储到localStorage
    localStorage.setItem(ExpiryKey, expiryDate.toString())
    Cookies.set(TokenKey, token, { expires: new Date(expiryDate) }) // 同时也存储到Cookie，确保后端能看到
    return token
}
// 移除Token
export function removeToken() {
    localStorage.removeItem(TokenKey)
    localStorage.removeItem(ExpiryKey)
    Cookies.remove(TokenKey)
}
// 跳转登录页
export function redirectToLogin() {
    window.location.href = '/login'
}
